import { login, logout, getInfo } from '@/apis/user'
import { getInfo as getCompanyInfo } from '@/apis/company'
import { resetRouter } from '@/router'
import {userRoleList} from "@/apis/role";

const state = {
  token: localStorage.getItem('token'),
  roles: null,
  currentUser: {},
  currentRole: {},
  currentCompany: {}
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_CURRENT_USER: (state, user) => {
    state.currentUser = user
  },
  SET_CURRENT_ROLE: (state, role) => {
    state.currentRole = role
  },
  SET_CURRENT_COMPANY: (state, company) => {
    state.currentCompany = company
  }
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { userId, companyId } = userInfo
    return new Promise((resolve, reject) => {
      login({ userId: userId, companyId: companyId }).then(response => {
        const { data } = response
        commit('SET_TOKEN', data.token)
        localStorage.setItem('token', data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getUserInfo({ commit, state }, companyId) {
    return new Promise((resolve, reject) => {
      getInfo(state.token, companyId).then(response => {
        const { data } = response

        if (!data) {
          reject('验证失败,请重新登录')
        }

        const { user } = data


        userRoleList({ userId: user.id, companyId }).then(res => {
          const roles = res.data?.map(item => item.roleName) || []
          if (!!roles && roles.length > 0) {
            if(roles.includes('超级管理员')) {
              commit('SET_CURRENT_ROLE', '超级管理员')
            } else if(roles.includes('系统管理员')) {
              commit('SET_CURRENT_ROLE', '系统管理员')
            } else {
              commit('SET_CURRENT_ROLE', roles[0])
            }
          }

          commit('SET_ROLES', roles)
          commit('SET_CURRENT_USER', user)

          resolve({ user, roles })
        })


      }).catch(error => {
        reject(error)
      })
    })
  },

  // selected company
  selectedCompany({ commit }, params) {
    return new Promise((resolve, reject) => {
      getCompanyInfo(params.companyId, params.userId).then(response => {
        const { data } = response
        const isBelongUser = params.userId === data.belongUser
        data.hasSuperAdmin = isBelongUser
        commit('SET_CURRENT_COMPANY', data)
        localStorage.setItem('companyId', data.id)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        localStorage.removeItem('token')
        localStorage.removeItem('companyId')
        resetRouter()

        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      localStorage.removeItem('token')
      localStorage.removeItem('companyId')
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
